import React from "react";
import RequestDetails from "../Requests/RequestDetails";

const CompletedApplicationDetails = () => {
  return <RequestDetails />;
};

export default CompletedApplicationDetails;
